import request from "../utils/request"

export function fetchSquareTopics() {
  return request({
    url: "/admin/square-topics",
    method: "get"
  })
}

export function saveSquareTopic(data) {
  return request({
    url: "/admin/square-topics",
    method: "post",
    data
  })
}

export function moveSquareTopic(id, direction) {
  return request({
    url: `/admin/square-topics/${id}/move`,
    method: "post",
    params: { direction }
  })
}

export function deleteSquareTopic(id) {
  return request({
    url: `/admin/square-topics/${id}`,
    method: "delete"
  })
}
